<template>
  <div class="box">
  <div class="is-flex">
    <h4 class="title is-size-5 mr-5">Job History</h4>
    <button class="button is-info small" @click="createHistoryCompany">+ Create</button>
  </div>
  <div v-if="historyCompany" class="is-flex is-justify-content-space-between">
    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Start</th>
          <th>End</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="word-break: break-all;">{{ historyCompany.history_company.name }}</td>
          <td>{{ `${historyCompany.month_start}/${historyCompany.year_start}` }}</td>
          <td>{{ `${historyCompany.month_end}/${historyCompany.year_end}` }}</td>
          <td>
            <button class="button is-success small" @click="editHistoryCompany">Edit</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ApplicantJobHistory',
  props: {
    applicant: {
      type: Object
    }
  },
  data () {
    return {
      historyCompany: null
    }
  },
  async created () {
    this.getHistoryCompanies()
  },
  methods: {
    ...mapMutations('modals', ['create']),
    async getHistoryCompanies () {
      const data = await this.$network_utils.getApplicantHistoryCompanies({ current_type: 'Applicant', current_applicant_id: this.applicant.resource_id })
      if (data.length == 0) return
      this.historyCompany = data.sort((a, b) => {
        if (b.year_start === a.year_start) {
          return b.month_start - a.month_start
        }
        return b.year_start - a.year_start
      })[0]
    },
    createHistoryCompany () {
      this.create({
        designator: 'applicant-history-companies-form-modal',
        component_name: 'ApplicantHistoryCompaniesForm',
        is_create: true,
        applicant_id: this.applicant.resource_id,
        modal_title: 'Create new History Company',
        props: {
          onSubmit: () => {
            this.getHistoryCompanies()
          }
        }
      })
    },
    editHistoryCompany () {
      this.create({
        designator: 'applicant-history-companies-form-modal',
        component_name: 'ApplicantHistoryCompaniesForm',
        data: this.historyCompany,
        applicant_id: this.applicant.resource_id,
        modal_title: this.historyCompany.history_company.name,
        props: {
          onSubmit: () => {
            this.getHistoryCompanies()
          }
        }
      })
    }
  }
}
</script>
